import React from 'react';

import WebsiteAdminFetchingSettingNumericFieldRow, {
	WebsiteAdminFetchingSettingNumericFieldRowUnit,
} from '~/components/app/WebsiteAdminFetchingSettingNumericFieldRow';



type Props = {
	name: string,
};

const WebsiteAdminFetchingSettingOnPageRequestsLimitNormalTotalFieldRow: React.FC<Props> = (props) => {
	const {
		name,
	} = props;

	return (
		<WebsiteAdminFetchingSettingNumericFieldRow
			autoValue={100}
			label="Max. on-page requests in total"
			name={name}
			unit={WebsiteAdminFetchingSettingNumericFieldRowUnit.None}
		/>
	);
};



export default WebsiteAdminFetchingSettingOnPageRequestsLimitNormalTotalFieldRow;
